<template>
  <v-container fluid class="pa-0">
      <v-card class="grey lighten-4 shadow-1 pa-3 card-r">
        <v-layout row wrap class="text-xs-center">

        <v-flex lg12 sm12 xs12 class="">
        <div class="text-primary f-15 font-weight-bold left">Language type</div>
         </v-flex>
         <v-flex lg3 xs12 class="pa-1">
        <v-select v-model="selectedLangCategory" solo :items="lang_type" 
        placeholder="Language">

        </v-select>
          </v-flex>

          <v-flex lg12 sm12 xs12 class="">
            <div class="text-primary f-15 font-weight-bold left">Question Category</div>
          </v-flex>
          <v-flex lg3 xs12 class="pa-1">
            <v-select v-model="selectedCategory" solo :items="test_type" placeholder="Select Category"></v-select>
          </v-flex>
          <v-flex lg6 xs12 class="pa-1" v-show="selectedCategory=='other'">
            <v-text-field v-model="newSelectedCategory" solo placeholder="New Question Category"></v-text-field>
          </v-flex>
          <!-- <v-flex lg3 xs12 class="pa-1 mt-2">
            <v-btn icon large v-show="!seen" v-on:click='seen = !seen' class="ma-0 left card-r grey lighten-3 f-12 card-r"><v-icon>add</v-icon></v-btn>
            <v-btn icon large v-show="seen" class="ma-0 left card-r grey lighten-3 f-12 card-r"><v-icon>add</v-icon></v-btn>
            <v-btn icon large v-show="seen" v-on:click='seen = !seen' class="ma-0 left ml-2 card-r grey lighten-3 f-12 card-r"><v-icon>close</v-icon></v-btn>
          </v-flex> -->
          <v-flex lg12 sm12 xs12 class="">
            <div class="text-primary f-15 font-weight-bold left">Scenario</div>
          </v-flex>
          <v-flex lg12 xs12 class="">
            <v-textarea rows="2" solo class="f-20" placeholder="Question scenario/situation" v-model="question.scenario"></v-textarea>
            <!--<v-text-field v-model="question.scenario" solo label="Question"></v-text-field>-->
            <!--<ckeditor :editor="editor" v-model=""  ="UploadAdapter"></ckeditor>-->
          </v-flex>
          <v-flex lg12 sm12 xs12 class="">
            <div class="text-primary f-15 font-weight-bold left mt-3">Choose Images</div>
          </v-flex>
          <v-flex lg12 xs12 class="xs-text-left">
              <input
                type="file"
                style="display:none"
                ref="imageInput"
                
                :accept="inputAccept"
                @change="onPickedFiles(file_for,$event)"
              >
              <v-btn solo
                    color=""
                    class="sim butt grey--text left ma-0 card-r mt-2"
                    @click="onPickFile('image','images')">
                    <v-icon class="mr-1 ml-0" right dark>mdi-cloud-upload</v-icon>
                Upload
              </v-btn>


          </v-flex>
          <v-flex lg12 sm12 xs12 class="pb-0 pt-3 pb-3" v-if="question.imagePreviews">
            <v-layout>
              <v-flex class="pt-2 pb-2 " xs6 v-for="img in question.imagePreviews" sm4 v-if="question.imagePreviews.length!=0">
                {{img.name}}
                <v-img class="border-r-2"
                       :src=img
                       height="100"
                       width="120"></v-img>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex lg12 sm12 xs12 class="">
            <div class="text-primary f-15 font-weight-bold left">Choose scenario/situation audio</div>
          </v-flex>
          <!--<v-flex lg6 xs12 class="">-->
            <!--<v-text-field v-model="question.scenario" solo label="Upload Audio"></v-text-field>-->
          <!--</v-flex>-->
          <v-flex lg2  xs12 class="align-center pt-1 text-xs-right right">
            <v-btn solo
                   color=""
                   class="sim butt grey--text left ma-0 card-r"
                   @click="onPickFile('audio','scenario_audio')">
                    <v-icon class="mr-1 ml-0" right dark>mdi-cloud-upload</v-icon>
                   Upload Audio
            </v-btn>
          </v-flex>
          <v-flex v-if="question.scenarioAudio" style="background-color:#e0e0e0;border:#c1c1c1 solid 1px;" lg12 sm12 xs12 class="pb-0 mt-2">
              <div >
                {{question.scenarioAudio.name}}
              </div>
            </v-flex>

          <v-flex lg12 sm12 xs12 class="pb-0 mt-3">
            <v-tabs v-model="active" class="transparent tab-active pt-2 w-100 mt-4" hide-slider>
              <v-tab ripple class="f-12">Question 1</v-tab>
              <v-tab ripple class="f-12">Question 2</v-tab>
              <v-tab ripple class="f-12">Question 3</v-tab>
              <v-tab ripple class="f-12">Question 4</v-tab>
              <!-- <v-tab ripple class="f-12" v-show="show">Question 4</v-tab> -->
              <!-- <v-div class="">
                <v-btn v-show="!show" v-on:click='show = !show' flat class="ma-0 ml-2 grey lighten-3 f-12 card-r"><v-icon>add</v-icon> Add Question</v-btn>
              </v-div>
              <v-div class="f-12">
                <v-btn icon v-on:click='show = !show' class="ma-0 ml-2 primary f-12 card-r"><v-icon>delete</v-icon></v-btn>
              </v-div> -->
              <v-tab-item v-for="(n,index) in 4" :key="n">
                <v-card flat class="mt-2 transparent">
                  <!-- <v-layout row wrap>-->
                  <!--<v-flex lg8 sm12 xs12 class="">-->
                  <!--<v-btn icon v-on:click='show = !show' class="ma-0 right ml-2 grey lighten-3 f-12 card-r"><v-icon>delete</v-icon></v-btn>-->
                  <!--</v-flex> -->
                  <!--</v-layout> -->
                  <v-layout row wrap>
                    <v-flex lg12 sm12 xs12 class="">
                      <div class="text-primary f-12 pt-1 pb-2 font-weight-bold left text-capitalize">Question</div>
                    </v-flex>
                    <v-flex lg8 xs12 class="px-0 pt-0">
                      <v-text-field v-model="question.questionList[index]" solo placeholder="Type the sub question for that main question scenario"></v-text-field>
                      <!--<ckeditor :editor="editor" v-model="editorData" :config="editorConfig"></ckeditor>-->
                    </v-flex>
                    </v-layout>
                   <v-layout row wrap>
                   <v-flex lg2 xs12 class="align-center pt-1 text-xs-right right">
                   <v-btn solo
                   color=""
                   class="sim butt grey--text left ma-0 card-r"
                   @click="onPickFile('audio','qu_audio',index)">
                    <v-icon class="mr-1 ml-0" right dark>mdi-cloud-upload</v-icon>
                   Question Audio
                    </v-btn>
                   </v-flex>
                       <v-flex v-if="question.questionAudios[index]" style="background-color:#e0e0e0;border:#c1c1c1 solid 1px;" lg12 sm12 xs12 class="pb-0">
                     <div>
                  {{question.questionAudios[index].name}} 
                     </div>
                     </v-flex>
                   </v-layout>

                  <v-layout row wrap>
                    <v-flex lg12 sm12 xs12 class="">
                      <div class="text-primary f-12 pt-1 pb-2 font-weight-bold left text-capitalize mt-4">Answer Explanation</div>
                    </v-flex>
                    <v-flex lg8 xs12 class="px-0 pt-0">
                      <v-textarea v-model="question.questionDescription[index]" solo rows="3" placeholder="Type the explanation of answer"></v-textarea>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex lg12 sm12 xs12 class="">
                      <div class="text-primary f-12 pt-1 pb-2 font-weight-bold left text-capitalize">Correct Answer</div>
                    </v-flex>
                    <v-flex lg12 xs12 class="px-0 pt-0">
                      <v-radio-group v-model="question.answersList[index]" :mandatory="false" row class="ma-0 pa-0">
                        <v-radio height="30" color="primary" label="Yes" value="yes"></v-radio>
                        <v-radio height="30" color="primary" label="No" value="no"></v-radio>
                      </v-radio-group>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap>
                   <v-flex lg2  xs12 class="align-center pt-1 text-xs-right right">
                   <v-btn solo
                   color=""
                   class="sim butt grey--text left ma-0 card-r mt-1 mb-3"
                   @click="onPickFile('audio','ex_audio',index)">
                    <v-icon class="ml-0 mr-1" right dark>mdi-cloud-upload</v-icon>
                   Explanation Audio
                    </v-btn>
                  </v-flex>
                       <v-flex v-if="question.answerAudios[index]" style="background-color:#e0e0e0;border:#c1c1c1 solid 1px;" lg12 sm12 xs12 class="pb-0">
                     <div>
                    {{question.answerAudios[index].name}}
                     </div>
                     </v-flex>
                   </v-layout>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-flex>
          <v-flex xs12 lg12 class="text-xs-center">
            <v-progress-circular
              indeterminate
              v-if=loading
              color="primary"
            ></v-progress-circular>
            <v-alert
              :value="true"
              color="success"
              icon="check_circle"
              v-if="alert.type=='success'"
              outline
            >
              {{alert.msg}}
            </v-alert>
            <v-alert
              :value="true"
              color="error"
              icon="warning"
              v-if="alert.type=='warning'"
              outline
            >
              {{alert.msg}}
            </v-alert>
          </v-flex>
          <v-flex xs12 class="text-xs-right">
            <v-btn @click="addQuestion('draft')" class="sim butt no-shadow card-r right " rounded>
              <i class="far fa-save mr-2"></i>
              Save as Draft
              </v-btn>
              
            <v-btn @click="addQuestion('publish')" class="sim primary no-shadow card-r right" rounded light>
              <i class="fas fa-plus-circle mr-2"></i>
              Add Question
              </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
  </v-container>
</template>
<script>
  /*eslint-disable */

  import api from "@/utils/backend-api"
	import { mapState } from 'vuex'
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
  import router from '@/router'

  // import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials';
  // import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold';
  // import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic';
  // import LinkPlugin from '@ckeditor/ckeditor5-link/src/link';
  // import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph';

  export default {
    data: () => ({
      radios: 'radio-1',
      loading:false,
      alert:{
        type:'',
        msg:''
      },
      show: false,
      seen: false,
      test_type: ['Teory', 'Snow', 'Long Drive'],
      lang_type:['en','da'],
      active: null,
      dialog: false,
      active1: 'question',
      editor: ClassicEditor,
      editorData: '<p></p>',
      editorConfig: {},
      selectedCategory:'',
      selectedLangCategory:'',
      newSelectedCategory:'',
      question:{
        scenario:'',
        scenarioAudio:'',
        questionList:['','','',''],
        questionAudios:['','','',''],
        questionAudiosNames:['','','',''],
        questionError:[false,false,false,false],
        questionDescription:['','','',''],
        questionDescError:[false,false,false,false],
        answersList:['','','',''],
        answerAudios:['','','',''],
        answerAudiosNames:['','','',''],
        answersListError:[false,false,false,false],
        images:[],
        imagePreviews:[],
        audios:[],
        audiosNames:[]
      },
      errorsIndex:[],
      inputAccept:'',
      file_for:'',
      qu_ans_index:'',

      UploadAdapter: function (loader) {
          this.loader = loader
          this.upload = () => {
            const body = new FormData();
            body.append('file', this.loader.file);
            // write your url for uploading and build your Request
            return fetch('http://domain/upload', {
              body: body,
              method: 'POST'
            })
              .then(response => response.json())
              .then(downloadUrl => {
                return {
                  // return your url for downloading
                  default: downloadUrl
                }
              })
              .catch(error => {
                console.log(error);
              });
          }
          this.abort = () => {
            console.log('Abort upload.')
          }
        }
    }),
    created:function(){
      api.getData('driver/viewQuestionCategory')
      .then(res=>{
        // Store.dispatch('setQuestionsList', res.data)
          let test_type=res.data

          let newtype=[]
          for(let x=0;x<test_type.length;x++){
            let type={
              text:test_type[x],
              value:test_type[x]
            }
            newtype.push(type)
          }
          let otherType={
            text:'other',
            value:'other'
          }
          newtype.push(otherType)
          this.test_type=newtype
      })
         self.loadQuestion()
         self.loadDraftQuestions()
                    
    },
    methods:{
        validateField(fieldType,index){
            if(fieldType=='question'){
              if(this.question.questionList[index].length==0){
                this.question.questionError[index]=true
              }else{
                this.question.questionError[index]=false
              }
            }else if(fieldType=='description'){
              if(this.question.questionDescription[index].length==0){
                this.question.questionDescError[index]=true
              }else{
                this.question.questionDescError[index]=false
              }
            }else if(fieldType=='answer'){
              if(this.question.answersList[index].length==0){
                this.question.answersListError[index]=true
              }else{
                this.question.answersListError[index]=false
              }
            }
        },
        onPickAudio(){
          this.$refs.audioInput.click();
        },
        onPickedAudio(audio_for,event) {
        
        const files = event.target.files;
            console.log(files)
            let fileName = files[0].name;
            if(audio_for=='scenario'){
              this.question.scenarioAudio=files[0];
            }else if(audio_for.startWith('q')){

              this.question.audios.push(files[0]);
              this.question.audiosNames.push(files[0]);
            }
            // if (fileName.lastIndexOf(".") <= 0) {
            //   return alert("Please add a valid file! ");
            // }

            // let fileName = files[0].name;
            // this.question.images.push(fileName);
            // if (fileName.lastIndexOf(".") <= 0) {
            //   return alert("Please add a valid file! ");
            // }

            // const fileReader = new FileReader();
            // fileReader.readAsDataURL(files[0]);
            // fileReader.addEventListener("load", () => {
            //   this.question.imagePreviews.push(fileReader.result);
            // });
        },
        onPickFile(value,filefor,index=''){ 
         
          this.file_for=filefor
          this.qu_ans_index=index
          if(value=='image'){
            this.inputAccept="image/png,image/jpg,image/jpeg"
          }else if(value=='audio' || 'qu_audio' || 'ex_audio'){
            this.inputAccept="audio/mp3"
          }
          setTimeout(()=>{
            this.$refs.imageInput.click();
          },500);
        },
        onPickedFiles(file_for,event) {
          
          const files = event.target.files;
          let fileName = files[0].name;
          if(file_for=='images'){
            this.question.images=[]
            this.question.images.push(files[0]);

            const fileReader = new FileReader();
            fileReader.readAsDataURL(files[0]);
            fileReader.addEventListener("load", () => {
              this.question.imagePreviews=[]
              this.question.imagePreviews.push(fileReader.result);
            });

          }else if(file_for=='scenario_audio'){
            this.question.scenarioAudio=files[0];
          }
          // else if(file_for.startWith('q')){

          //   this.question.audios.push(files[0]);
          //   this.question.audiosNames.push(files[0]);
          // }
          else if(file_for=='qu_audio'){
  
            this.question.questionAudios[this.qu_ans_index]=files[0];
            this.question.questionAudiosNames[this.qu_ans_index]=files[0].name;
              // this.question.audiosNames.push(files[0]);
          }else if(file_for=='ex_audio'){
            this.question.answerAudios[this.qu_ans_index]=files[0];
            this.question.answerAudiosNames[this.qu_ans_index]=files[0].name;
          }

          // if (fileName.lastIndexOf(".") <= 0) {
          //   return alert("Please add a valid file! ");
          // }

        },
        validateQuestions(){
          
          let errorsIndex=[]
          let correctQuestions=[]
          let hasError=false
          for(let x=0;x<4;x++){
            this.validateField('question',x)
            this.validateField('description',x)
            this.validateField('answer',x)
            // this.validateField('qu_audio',x)
            // this.validateField('ex_audio',x)

            if(this.question.questionList[x].length>0 || this.question.questionDescription[x].length>0 || this.question.answersList[x].length>0 ){
              if(this.question.questionList[x].length>0 && this.question.questionDescription[x].length>0 && this.question.answersList[x].length>0){
                correctQuestions.push(x)
              }else{
                errorsIndex.push(x)

                hasError=true
                this.type="warning"
                this.msg="Failed"
              }
            }
          }
          if(errorsIndex.length!=0){
            this.errorsIndex=errorsIndex
            if(hasError==true){
              this.alert.type="warning"
              var new_array = this.errorsIndex.map(function(e) {
                e= 'Question '+(parseInt(e)+1)
                return e;
              });
              this.alert.msg="Please check the all fields in "+new_array
              return true
            }
          }else{
            if(correctQuestions.length>0){
              this.alert.type=""
              this.alert.msg=""
              return hasError
            }else{
              this.alert.type="warning"
              this.alert.msg="Please add minimum 1 question"
              return true
            }
          }
        },
        addQuestion(status){
          if(this.selectedCategory==''){
            this.alert.type="warning"
            this.alert.msg="Please choose category"
            return
          }
          if(this.question.scenario==''){
            this.alert.type="warning"
            this.alert.msg="Please enter scenario"
            return
          }

          if(!this.validateQuestions()){
              // let Data={
              //   lang:'en',
              //   category:this.selectedCategory=='other'?this.newSelectedCategory:this.selectedCategory,
              //   situation:this.question.scenario,
              //   status:'publish'
              // }
              this.loading=true
              this.alert.type=""
              try{
               
                  let self=this
                  let formData=new FormData()
                  // formData.append('lang','en')
                  
                  formData.append('lang',this.selectedLangCategory)
                  formData.append('category',this.selectedCategory=='other'?this.newSelectedCategory:this.selectedCategory,)
                  formData.append('situation',this.question.scenario)
                  formData.append('status',status)
                  formData.append('situation_audio',this.question.scenarioAudio==null?'':this.question.scenarioAudio)
                  for(let x=0;x<4;x++){
                    formData.append('q'+(x+1),this.question.questionList[x]==null?'':this.question.questionList[x])
                    formData.append('q'+(x+1)+'_explanation',this.question.questionDescription[x]==null?'':this.question.questionDescription[x])
                    // formData.append('q'+(x+1)+'_audio',this.question.audios[x]==null?'':this.question.audios[x])
                    formData.append('a'+(x+1),this.question.answersList[x]==null?'':this.question.answersList[x])
                    formData.append('q'+(x+1)+'_audio',this.question.questionAudios[x]==null?'':this.question.questionAudios[x])
                    formData.append('a'+(x+1)+'_audio',this.question.answerAudios[x]==null?'':this.question.answerAudios[x])
                    
                  }
                  // for(let x=0;x<this.question.images.length;x++){
                    formData.append('picture',this.question.images[0]==null?'':this.question.images[0])
                  // }
                  api.postData('driver/createQuestion',formData)
                  .then(res=>{
                    if(res.status==201){
                      self.alert.type="success"
                      self.alert.msg="Question successfully created"
                      self.loading=false
                    }

                    self.loadQuestion()
                    self.loadDraftQuestions()
                    // setTimeout(()=>{
                      // router.push('/examstab#draft')
                      // Store.dispatch(setQuestionsList)
                    // },4000)
              

                  }).catch(err=>{
                    self.loading=false
                    self.alert.type="warning"
                    self.alert.msg="Question creation failed"

                  })
              }catch(ex){
                  this.loading=false
                  self.alert.type="warning"
                  self.alert.msg="Question creation failed"
              }
          }

        },
        loadQuestion(){
          api.postData('driver/viewQuestions')
          .then(res=>{
            Store.dispatch('setQuestionsList', res.data)
                 router.push('/examstab#allquestions')      

              // self.questionsInfo=res.data
          })
        },
        loadDraftQuestions(){
          api.postData('driver/viewDraftQuestions')
          .then(res=>{
            Store.dispatch('setDraftQuestions', res.data.data)
            router.push('/examstab#draft')
            // this.draftData=res.data.data
          })
        },
    },
    computed: {
      ...mapState({
        questionsList: 'questionsList',
        questionsCategories:'questionsCategories'
    })
  }
}

</script>
<style>
 .dddsa ::-webkit-scrollbar {
    display: none!important;
  }

</style>



// WEBPACK FOOTER //
// src/pages/pages/exams/CreateQuestions.vue